import { adjustInputWidth } from "./auto_width_input.js";
import { formatAmount } from "./format_amount.js";

/**
 * PwywSlider – keeps slider interaction fully client-side during drag.
 * Only pushes the value to the server on release (change / mouseup / touchend).
 *
 * Reads configuration from data attributes on the <input type="range">:
 *   data-min, data-max, data-factor, data-currency
 */
export const PwywSlider = {
  mounted() {
    this._pushTimer = null;

    // Stop "input" from reaching the form's phx-change
    this.el.addEventListener("input", (e) => {
      e.stopPropagation();
      // Hide the "Slide to adjust" tooltip immediately on first interaction
      document
        .querySelectorAll(".floating-ui-tooltip")
        .forEach((el) => el.remove());
      this.syncVisuals(parseInt(this.el.value, 10));
    });

    // Push to server only on release / final change
    this.el.addEventListener("change", () => this.pushValue());
    this.el.addEventListener("mouseup", () => this.pushValue());
    this.el.addEventListener("touchend", () => this.pushValue());
  },

  syncVisuals(amount) {
    const min = parseInt(this.el.dataset.min, 10) || 1;
    const max = parseInt(this.el.dataset.max, 10) || 50;
    const factor = parseInt(this.el.dataset.factor, 10) || 1;
    const pct =
      amount <= min
        ? 0
        : amount >= max
          ? 100
          : ((amount - min) / (max - min)) * 100;
    const displayAmount = amount * factor;

    // Fill bar
    const fill = document.getElementById("pwyw-track-fill");
    if (fill) fill.style.width = `${pct}%`;

    // Thumb
    const thumb = document.getElementById("pwyw-thumb");
    if (thumb) {
      thumb.style.left = `max(0%, min(calc(100% - 24px), calc(${pct}% - 12px)))`;
    }

    // Display amount input (formatted with thousand separators)
    const input = document.getElementById("pwyw-amount-input");
    if (input) {
      input.value = formatAmount(displayAmount);
      adjustInputWidth(input);
    }

    // Scale labels
    document.querySelectorAll("[data-scale-label]").forEach((label) => {
      const v = parseInt(label.dataset.scaleLabel, 10);
      label.classList.toggle("text-robe-950", displayAmount >= v);
      label.classList.toggle("text-robe-400", displayAmount < v);
    });

    // Impact items (both desktop and mobile panels) – toggle active styling
    document.querySelectorAll("[data-impact-threshold]").forEach((el) => {
      const threshold = parseInt(el.dataset.impactThreshold, 10);
      const active = amount >= threshold;
      if (active) {
        el.classList.remove("opacity-60", "text-robe-600");
        el.classList.add("opacity-100", "text-robe-25");
      } else {
        el.classList.remove("opacity-100", "text-robe-25");
        el.classList.add("opacity-60", "text-robe-600");
      }
    });

    // Button amount text (formatted with thousand separators)
    const currency = this.el.dataset.currency || "";
    const btnAmount = document.getElementById("pwyw-btn-amount");
    if (btnAmount)
      btnAmount.textContent = `${currency}${formatAmount(displayAmount)}`;
  },

  pushValue() {
    clearTimeout(this._pushTimer);
    const val = this.el.value;
    this.pushEvent("pwyw_change", {
      pwyw: { amount: val },
      _target: ["pwyw[amount]"],
    });
  },
};
